/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_QuitInputs */

const bn_action_quit = /** @type {(inputs: Action_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রস্থান করুন`)
};

const de_action_quit = /** @type {(inputs: Action_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufhören`)
};

const el_action_quit = /** @type {(inputs: Action_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εγκαταλείπω`)
};

const en_action_quit = /** @type {(inputs: Action_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quit`)
};

const es_action_quit = /** @type {(inputs: Action_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abandonar`)
};

const fr_action_quit = /** @type {(inputs: Action_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitter`)
};

const hi_action_quit = /** @type {(inputs: Action_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छोड़ना`)
};

const hu_action_quit = /** @type {(inputs: Action_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilép`)
};

const id_action_quit = /** @type {(inputs: Action_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berhenti`)
};

const it_action_quit = /** @type {(inputs: Action_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esentato`)
};

const ja_action_quit = /** @type {(inputs: Action_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`やめる`)
};

const ko_action_quit = /** @type {(inputs: Action_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그만두다`)
};

const nl_action_quit = /** @type {(inputs: Action_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontslag nemen`)
};

const pl_action_quit = /** @type {(inputs: Action_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrezygnować`)
};

const pt_action_quit = /** @type {(inputs: Action_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desistir`)
};

const ru_action_quit = /** @type {(inputs: Action_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Покидать`)
};

const sv_action_quit = /** @type {(inputs: Action_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sluta`)
};

const tr_action_quit = /** @type {(inputs: Action_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çıkış yapmak`)
};

const uk_action_quit = /** @type {(inputs: Action_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вийти`)
};

const vi_action_quit = /** @type {(inputs: Action_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ bỏ`)
};

const zh_action_quit = /** @type {(inputs: Action_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`辞职`)
};

const zh_hant_action_quit = /** @type {(inputs: Action_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`辭職`)
};

/**
* | output |
* | --- |
* | "Quit" |
*
* @param {Action_QuitInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const action_quit = /** @type {((inputs?: Action_QuitInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_QuitInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_action_quit(inputs)
	if (locale === "de") return de_action_quit(inputs)
	if (locale === "el") return el_action_quit(inputs)
	if (locale === "en") return en_action_quit(inputs)
	if (locale === "es") return es_action_quit(inputs)
	if (locale === "fr") return fr_action_quit(inputs)
	if (locale === "hi") return hi_action_quit(inputs)
	if (locale === "hu") return hu_action_quit(inputs)
	if (locale === "id") return id_action_quit(inputs)
	if (locale === "it") return it_action_quit(inputs)
	if (locale === "ja") return ja_action_quit(inputs)
	if (locale === "ko") return ko_action_quit(inputs)
	if (locale === "nl") return nl_action_quit(inputs)
	if (locale === "pl") return pl_action_quit(inputs)
	if (locale === "pt") return pt_action_quit(inputs)
	if (locale === "ru") return ru_action_quit(inputs)
	if (locale === "sv") return sv_action_quit(inputs)
	if (locale === "tr") return tr_action_quit(inputs)
	if (locale === "uk") return uk_action_quit(inputs)
	if (locale === "vi") return vi_action_quit(inputs)
	if (locale === "zh") return zh_action_quit(inputs)
	return zh_hant_action_quit(inputs)
});